export default {
  black: '#000',
  grey: '#808080',
  transparent: '#00000000',
  white: '#fff',
  greyIcon: '#d3d3d3',
  defaultGrey: '#e0e0e0',
  orangeIcon: 'orange',
  redIcon: '#ff0000',
  disabledGray: '#e3e4e3',
  lightGrey: '#f0f1f0',
  lightGrey2: '#f2f3f2',
  gray400: '#E2E3E2',
  lightGreyBorder: '#e5e6e5',
  darkGrey: '#333833',
  blue: '#2979fe',
  red: '#f44336',
  redLight: '#fa9c92',
  danger: '#f44335',
  darkBlue: '#004e9b',
  success: '#00d800',
  inputBorder: 'rgba(0, 0, 0, 0.23)',
  lightGreen: '#d9ff97',
  buttonSuccess: '#33cc32',
  lightGreen2: '#bdeaa6',
  lightBlue: '#AAD5FF'
};
